import { rankWith, schemaTypeIs } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import Popover from "@mui/material/Popover";
import SFTypography from "../../../components/typography";
import getStyled from "../../../hooks/getStyled";
import {SFCheckboxIdeterminateIcon, SFCheckboxChecked, SFCheckboxUnchecked} from "../../icons";

const { styled } = getStyled();

const FormControlStyled = styled(FormControl)`
  flex-direction: row;
  align-items: center;
  .MuiFormHelperText-root {
    margin: 0;
  }
`;

const CheckboxRenderer = ({ data, handleChange, path, uischema }) => {
  const { t } = useTranslation();

  const onChange = (e) => {
    const value = e.target.checked;
    handleChange(path, value);
  };

  return (
    <FormControlStyled fullWidth>
      <FormControlLabel
        disabled={uischema.options?.readonly}
        control={
          <Checkbox
            checked={data ? true : false}
            indeterminateIcon={
              <SFCheckboxIdeterminateIcon size="medium" color="blue400" />
            }
            checkedIcon={<SFCheckboxChecked size="medium" color="blue400" />}
            icon={<SFCheckboxUnchecked size="medium" color="grey500" />}
          />
        }
        label={uischema.i18nKey ? t(uischema.i18nKey) : uischema.label}
        onChange={onChange}
      />
      {uischema.help && (
        <FormHelperText>
          <PopupState variant="popover">
            {(popupState) => (
              <div>
                <InfoOutlinedIcon
                  sx={{ cursor: "pointer" }}
                  fontSize="small"
                  {...bindTrigger(popupState)}
                />
                <Popover
                  {...bindPopover(popupState)}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                >
                  <SFTypography variant="body1" sx={{ p: 2 }}>
                    {t(uischema.help.i18nKey)}
                  </SFTypography>
                </Popover>
              </div>
            )}
          </PopupState>
        </FormHelperText>
      )}
    </FormControlStyled>
  );
};

export const CheckboxTester = rankWith(101, schemaTypeIs("boolean"));

export default withJsonFormsControlProps(CheckboxRenderer);
